














import Vue from 'vue'
import Navigation from '@/components/Navigation.vue'
import EmailPopup from '@/components/EmailPopup.vue'
import GetWindowSize from '@/components/GetWindowSize.vue'
import Notifications from '@/components/Notifications.vue'

export default Vue.extend({
  components: {
    Navigation,
    EmailPopup,
    GetWindowSize,
    Notifications,
  },
  created() {
    this.$store.dispatch('setCSOFlag')
    this.$store.dispatch('setUserName')
    this.$store.dispatch('setSelectedPart', 'setSelectedPart')
  },
  mounted() {
    // this.$store.commit('setNotificationsVisibility', true)
  },
})
